import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoginComponent } from '../features/login/login.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';

const COMPONENTS = [TopBarComponent, ForbiddenComponent, NotFoundComponent, LoadingSpinnerComponent, LoginComponent];

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: COMPONENTS,
  exports: [...COMPONENTS, CommonModule, RouterModule],
})
export class SharedModule {}
